module.exports = __webpack_public_path__ + "img/gallery03.9a4aca35.png";